package com.jingfangpai.medicalRecord.model

import com.jingfangpai.common.orm.mapping.MedicalRecordDiagnosis
import kotlinx.serialization.Serializable

@Serializable
class MedicalRecordDiagnosisDto: MedicalRecordDiagnosis() {
    var syndromeIndicationName:String?=null
}